import React from "react";
import ReactDOM from "react-dom";

import { BrowserRouter } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";

import { Provider } from "react-redux";
import { store } from "./storeConfig/store";

import App from "./App";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// Configuração do React Query
const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			retry: false,
			refetchOnmount: false,
			refetchOnReconnect: false,
			cacheTime: (1000 * 60) * 60,
			staleTime: Infinity,
		},
	},
});

// Tema customizado do Material Design
const theme = createTheme({
	palette: {
		primary: {
			main: "#2B55B2",
			dark: "#002d82",
		},
	},
	typography: {
		fontSize: 16,
		h3: {
			fontWeight: 700,
			fontSize: "2.2rem",
		},
		h4: {
			fontWeight: 700,
			fontSize: "1.75rem",
		},
		h5: {
			fontWeight: 500,
		},
		h6: {
			fontWeight: 500,
		},
	},
	// Todos os componentes possui uma classe
	// que pode user usada para modificações
	components: {
		MuiFormLabel: {
			styleOverrides: {
				root: {},
			},
		},
	},
});

ReactDOM.render(
	<React.StrictMode>
		<ThemeProvider theme={theme}>
			<QueryClientProvider client={queryClient}>
				<Provider store={store}>
					<BrowserRouter>
						<App />
					</BrowserRouter>
				</Provider>
			</QueryClientProvider>
		</ThemeProvider>
	</React.StrictMode>,
	document.getElementById("root")
);
